const translations: Record<string, string> = {
  "ak_fc_rain": "Дощ",
  "ak_fc_drizzle": "Мряка",
  "ak_fc_clear": "Ясно",
  "ak_fc_partly_cloudy": "Мінлива хмарність",
  "ak_fc_cloudy": "Хмарно",
  "ak_fc_overcast": "Похмуро",
  "ak_fc_current_weather_open_meteo": "Погода зараз (Open-Meteo) · {{sky}}",
  "ak_fc_m_s": "м/с",
  "ak_fc_sunrise": "Схід сонця {{t}}",
  "ak_fc_sunset": "Захід сонця {{t}}",
  "ak_fc_online": "Онлайн",
  "ak_fc_kw": "кВт",
  "ak_fc_kwh": "кВт·г",
  "ak_fc_radiation_min_corrected": "Радіація кор.хв",
  "ak_fc_cloud_cover": "Хмарність",
  "ak_fc_mw": "МВт",
  "ak_fc_generated_today": "Згенеровано сьогодні",
  "ak_fc_mwh": "МВт·год",
  "ak_fc_hide_series_on_chart": "Приховати серію на графіку",
  "ak_fc_show_series_on_chart": "Показати серію на графіку",
  "ak_fc_kwh_2": "кВт·год",
  "ak_fc_per_day": "за добу",
  "ak_fc_base_forecast": "Base прогноз",
  "ak_fc_ecmwf_forecast": "ECMWF прогноз",
  "ak_fc_accumulated_since_the_start_of_the_day": "Накопичено з початку доби станом на {{hh}}:{{mm}} (час станції); поточна година врахована пропорційно часу, що минув",
  "ak_fc_deviation_from_the_d_2_forecast_snapsh": "Розбіжність із прогнозом D-2 (знімок {{at}})",
  "ak_fc_current_weather": "Погода зараз · {{sky}}",
};

export default translations;
